import { QuestionType } from './types';

export const QUESTION_HINT_EXAMPLES: Record<QuestionType, string> = {
    [QuestionType.TEXT]: 'Example: Why did the buyer not want the product? A: Customer found the price too high',
    [QuestionType.BOOLEAN]: 'Example: Did the agent offer additional product X? A: yes',
    [QuestionType.NUMERIC]: 'Example: How proactive was the agent in promoting the sale? A: 8',
    [QuestionType.MULTISELECT]: 'Example: Which additional services were discussed during the call (Service 1, Service 2)? A: Service 2',
    [QuestionType.FORMULA]: '',
};

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
    [QuestionType.TEXT]: 'Freeform text',
    [QuestionType.BOOLEAN]: 'Yes/No',
    [QuestionType.NUMERIC]: 'Numeric scale (1-10)',
    [QuestionType.MULTISELECT]: 'Multiple choice',
    [QuestionType.FORMULA]: 'Formula',
};

export const QUESTION_TIPS = [
    'Keep questions specific and actionable.',
    'Use open-ended questions to gather detailed insights.',
    'Order questions from general to specific.',
];

export const DEFAULT_NUMERIC_RANGE = {
    MIN: 1,
    MAX: 10,
} as const;

export const RATING_SCALE_LABEL = '6-10: 1, 5: 0.5, below 5: 0';
